import { render } from "./App.vue?vue&type=template&id=243546bc"
const script = {}

import "./App.vue?vue&type=style&index=0&id=243546bc&lang=css"

import exportComponent from "F:\\allNewWeb\\ant-vue\\haopingdashi\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__